export default "__VITE_ASSET__ee7c4213__"